export enum StatusIndicatorType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning',
}

export const StatusIndicator = ({
  text,
  type = StatusIndicatorType.POSITIVE,
}: {
  text?: string;
  type: StatusIndicatorType;
}) => {
  return (
    <div className="flex flex-row items-center gap-1">
      <div className="h-5 w-5 rounded-full border-[1.5px] border-white/50 p-[2px]">
        <div
          className={`h-full w-full rounded-full ${
            type === StatusIndicatorType.POSITIVE
              ? 'bg-custom-green-glow'
              : type === StatusIndicatorType.WARNING
                ? 'bg-custom-yellow'
                : 'bg-error-red'
          }`}
        ></div>
      </div>
      <span className="text-2xs">{text}</span>
    </div>
  );
};
